import EntryActionTypes from '../../constants/EntryActionTypes';

export const fetchDailyReports = (currentDay, interval) => ({
  type: EntryActionTypes.DAILY_REPORTS_FETCH_REQUEST,
  payload: {
    currentDay,
    interval,
  },
});

export const fetchMonthlyReports = (currentMonth) => ({
  type: EntryActionTypes.MONTHLY_REPORTS_FETCH_REQUEST,
  payload: {
    currentMonth,
  },
});

export const fetchYearlyReports = (currentYear) => ({
  type: EntryActionTypes.YEARLY_REPORTS_FETCH_REQUEST,
  payload: {
    currentYear,
  },
});

export const fetchCurrentReports = () => ({
  type: EntryActionTypes.CURRENT_REPORTS_FETCH_REQUEST,
  payload: {},
});
